<template>
  <!-- div v-if="appointedcarrierdata.AppointedCarriers.length === 0">No Carrier Appointed to this Agency</div -->
  <span>
    <b-row v-for="(subItem, subKey) in appointedcarrierdata" :key="subKey" class="mx-3 py-4 border-bottom ac-carrier-container">
      <b-col class="pl-0 col-12 col-xl-2">
          <b-img :src="subItem.CarrierSvgLogoUrl" fluid-grow :alt="subItem.CarrierName">nutan</b-img>
      </b-col>
      <credential-updater  :appointedcarrierdata="appointedcarrierdata" :subItem="subItem"  @CredentialUpdateMsg='UpdateSucessStatus'></credential-updater>
    </b-row>
  </span>
</template>

<script>
/* eslint-disable */
import CredentialUpdater from './CredentialUpdater';

export default {
  components: {
    CredentialUpdater,
  },
  props: ['appointedcarrierdata'],
  data() {
    return {
      name: '',
      id: '',
      selected: [], // Must be an array reference!
      passwordHidden: true,
      form: {
        username: '',
        password: '',
      },
    };
  },
  methods: {
    UpdateSucessStatus(statusflag){
       this.$emit("CredentialSubmitStatus",statusflag);
     console.log('event emitter', statusflag)
    },
  
    runThis() {
      console.log('hi');
    },
    toggleAll(states, subKey, toggleType) {
      if (toggleType === 'selectall') {
        Object.values(states).forEach((key) => {
          const stateKey = key;
          if (stateKey.IsEnabled === true) {
            stateKey.IsActive = true;
          }
        });
      }
      if (toggleType === 'clearall') {
        Object.values(states).forEach((key) => {
          const stateKey = key;
          if (stateKey.IsEnabled === true) {
            stateKey.IsActive = false;
          }
        });
      }
    },
  },
};
</script>

<style scoped>
.credentials {
  display: flex;
  align-items: center;
 }
 .credentials LABEL {
    font-size: 12px;
    font-weight: 600;
  }
.password-field {
  display: flex;
  align-items: center;
}
.revealer {
  position: relative !important;
  left: -30px !important;
}
.ac-carrier-container {
  display:flex;
  align-items:center;
}
img.img-fluid{
  max-width: 180px;
  height: inherit !important;
}

@media (min-width: 1200px) {
  .fieldset-width {
    width: 18%;
  }
}

@media (min-width: 992px) and (max-width: 1199px) {
  .fieldset-width {
    width: 30%;
  }
}

@media (min-width: 768px) and (max-width: 991px) {
  .fieldset-width {
    width: 29.5%;
  }
}

@media (min-width: 576px) and (max-width: 767px) {
  .fieldset-width {
    width: 44%;
  }
}

@media (max-width: 575px) {
  .fieldset-width {
    width: 100%;
  }
}
</style>

<style>
</style>



// WEBPACK FOOTER //
// src/components/admin/agencies/CarrierLogin.vue?0916b79a